// MODULES
import axios from "axios";
/* From snake_case object to camelCase */
import camelcaseKeys from "camelcase-keys";

// Axios instance for gemmici Api service calls
export const gemmiciApiServiceClient = axios.create({
  baseURL: process.env.VUE_APP_URL_API,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  }
});
// ADD AUTHENTIFICATION FOR HEADER CALL
export function setBearerTokenForGemmiciApiServiceClient(accessToken) {
  gemmiciApiServiceClient.defaults.headers.common["Authorization"] =
    "Bearer " + accessToken;
}
// REMOVE AUTHENTIFICATION FOR HEADER CALL
export function deleteBearerTokenForGemmiciApiServiceClient() {
  delete gemmiciApiServiceClient.defaults.headers.common["Authorization"];
}
// REFRESH ACCESS TOKEN
function JWTRefreshAPI(refreshToken) {
  return gemmiciApiServiceClient.post("auth/jwt/refresh/", {
    refresh: refreshToken
  });
}
// REMOVE ACCESS AND REFRESH TOKEN IN LOCALSTORAGE
function removeAccessAndRefreshToken() {
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
}
// REFRESH ACCESSTOKEN
function refreshAccessAndRefreshTokenForGemmiciApiService() {
  return new Promise((resolve, reject) => {
    JWTRefreshAPI(localStorage.getItem("refresh_token"))
      .then(response => {
        localStorage.setItem("access_token", response.data.access);
        setBearerTokenForGemmiciApiServiceClient(
          localStorage.getItem("access_token")
        );
        resolve(response.data.access);
      })
      .catch(() => {
        reject();
      });
  });
}

// GEMMICI API SERVICE INTERCEPTOR
gemmiciApiServiceClient.interceptors.response.use(
  response => {
    // /* From snake_case object to camelCase data response */
    response.data = camelcaseKeys(response.data, { deep: true });
    // Return a successful response back to the calling service
    return response;
  },
  error => {
    // Return any error which is not due to authentication back to the calling service
    if (
      error.response.status !== 401 ||
      error.config.url == "auth/jwt/create/"
    ) {
      return new Promise((resolve, reject) => {
        reject(error);
      });
    }
    // Logout user if token refresh didn't work
    const refreshUrl = "auth/jwt/refresh/";
    if (error.config.url == refreshUrl) {
      removeAccessAndRefreshToken();
      location.reload();
      return Promise.reject(error);
    }

    // Logout user if refresh token does not exist in Localstorage
    if (
      error.response.status === 401 &&
      localStorage.getItem("refresh_token") == null
    ) {
      this.removeAccessAndRefreshToken();
      location.reload();
      return Promise.reject(error);
    }
    // Access Token invalid: try to refresh token then request again
    if (
      error.response.status === 401 &&
      error.response.data.messages[0].token_type === "access" &&
      error.response.data.messages[0].message === "Token is invalid or expired"
    ) {
      // Try request again with new token
      return refreshAccessAndRefreshTokenForGemmiciApiService()
        .then(accessToken => {
          // New request with new token
          return new Promise((resolve, reject) => {
            error.config.headers["Authorization"] = "Bearer " + accessToken;
            gemmiciApiServiceClient
              .request(error.config)
              .then(response => {
                resolve(response);
              })
              .catch(error => {
                reject(error);
              });
          });
        })
        .catch(() => {
          removeAccessAndRefreshToken();
          location.reload();
          return Promise.reject();
        });
    }
  }
);
